'use strict';

//========================
//====AJAX SUBMIT FORM====
//========================

/**
 * Odesle formular pres AJAX
 *
 * @param {jQuery} $form
 * @param {jQuery} $formMsgContainer
 * @param {String} dataType
 * @param {Object} gtmData
 * @param successCallback
 */
export function ajaxSubmitForm($form, $formMsgContainer, dataType, gtmData, successCallback) {
    dataType = dataType || 'json';
    gtmData = gtmData || false;
    successCallback = successCallback || false;

    var $formErrorMsg = $formMsgContainer.find('.error');
    var $formSuccessMsg = $formMsgContainer.children('.success');

    $.ajax({
        method: 'post',
        dataType: dataType,
        url: $form.attr('action'),
        data: $form.serialize(),
        success: function (response) {
            $formMsgContainer.find('div').hide(); //pokud byly jiz predtim zobrazene error hlasky -> skryjeme
            if (response.status == 'error') {
                $formErrorMsg.show();
            } else if (response.status == 'success') {
                $formSuccessMsg.show();

                if(gtmData && dataLayer) {
                    dataLayer.push(gtmData);
                }

                if (successCallback !== false) {
                    successCallback();
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/ajaxForm.js